import axios, { CancelTokenSource } from 'axios';
import { useContext, useRef } from 'react';
import useSWR from 'swr';
import {
  AXIOS_CANCEL_MSG,
  Page, MasterScheduleFlags,
} from '../api/models';
import { ConfiguratorContext } from '../context';
import {ListTruckRequest} from "../api";

type MasterScheduleFlagsProps = ListTruckRequest & {
  disabled?: boolean;
}

export const useMasterScheduleFlags = (props: MasterScheduleFlagsProps) => {

  const cancelTokenSourceRef = useRef<CancelTokenSource>();
  const configurator = useContext(ConfiguratorContext);

  const fetcher = async ( props:MasterScheduleFlagsProps  ) : Promise<Page<MasterScheduleFlags> | undefined> => {

    if ( cancelTokenSourceRef.current ) {
      cancelTokenSourceRef.current.cancel( AXIOS_CANCEL_MSG );
    }
    const cancelSource = axios.CancelToken.source();
    cancelTokenSourceRef.current = cancelSource;

    try {
      const resp = await configurator.api.fetchMasterScheduleFlags(props, cancelSource.token )
      cancelTokenSourceRef.current = undefined;

      return resp.data;
    }
    catch(e: any) {
      const id = e.response?.data?.message || e.message ;
      if ( id === AXIOS_CANCEL_MSG ) return;
      throw e;
    }
  }

  // Use SWR for data fetching
  return useSWR([
    'fetchMasterScheduleFlags',
    props
  ],
    ([_k, p]) => fetcher(p),
    {
      //maybe unnecessary
      shouldRetryOnError: false,
      revalidateOnFocus: false,
      /*
      revalidateIfStale: false,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      revalidateOnMount: false,
       */
      //maybe unnecessary
      dedupingInterval:1 
    }
  );
};


export default useMasterScheduleFlags;

